import React, { useCallback } from 'react';
import { useRecoilState } from 'recoil';
import { lookupState } from 'state/atoms';

import { Product } from 'components';
import Header from 'pages/NewCaseSearch/subcomponents/Header';
import AddToRma from 'pages/NewCaseSearch/subcomponents/AddToRma';
import RmaFiels from 'pages/NewCaseSearch/subcomponents/RmaFields';
import { WarrantyActions } from 'pages/NewCaseSearch/styledComponents';
import { Flex } from 'components/layout/Flex';
import {
  ReturnLink,
  SelectPartMessage,
} from 'pages/NewCaseSearch/subcomponents/VisualComponents';
import PartNotFoundMessage from 'pages/NewCaseSearch/subcomponents/PartNotFoundMessage';
import { isPartEligibleForWarranty } from 'pages/NewCaseSearch/helpers';

const SamePartNumberMessage = ({ onCancel }) => (
  <SelectPartMessage>
    <p>
      This part number is already associated with the current serial number.
      Click{' '}
      <ReturnLink href="#" onClick={onCancel}>
        here
      </ReturnLink>{' '}
      to return.
    </p>
  </SelectPartMessage>
);

const NotSearchedMessage = ({ onCancel }) => (
  <SelectPartMessage>
    <p>
      Please, search for the part number to proceed. Click{' '}
      <ReturnLink href="#" onClick={onCancel}>
        here
      </ReturnLink>{' '}
      to return.
    </p>
  </SelectPartMessage>
);

const ProductDetails = ({ selectedResult }) => (
  <Flex>
    <Flex direction="column" spacing="space-between" grow="1">
      <Product
        statusMessage={
          !isPartEligibleForWarranty(selectedResult.product)
            ? 'This serial number is out of warranty and not eligible for RMA'
            : null
        }
        {...selectedResult.product}
      />
      <RmaFiels />
    </Flex>
    <WarrantyActions>
      <AddToRma />
    </WarrantyActions>
  </Flex>
);

const IncorrectPartNumber = () => {
  const [currentLookupState, setLookupState] = useRecoilState(lookupState);
  const {
    incorrectResult,
    selectedResult,
    searchedPartNumber,
  } = currentLookupState;
  const { serialNumber, product } = incorrectResult;
  const headerCard = [{ title: 'Serial #:', value: serialNumber }];

  const cancelIncorrectPartNumber = useCallback(
    (event) => {
      event.preventDefault();

      setLookupState({
        ...currentLookupState,
        selectedResult: { ...currentLookupState.incorrectResult },
        incorrectResult: null,
        incorrectPartNumber: false,
      });
    },
    [currentLookupState, setLookupState]
  );

  const searchedForSamePart = product.partNumber === searchedPartNumber;
  const hasProductDetails = selectedResult && selectedResult.product;

  const renderMessage = () => {
    // Search succeded
    if (hasProductDetails) {
      return <ProductDetails selectedResult={selectedResult} />;
    }

    // Nothing searched
    if (!searchedPartNumber) {
      return <NotSearchedMessage onCancel={cancelIncorrectPartNumber} />;
    }

    // Tried to search for the item that was associated with the SN
    if (searchedForSamePart) {
      return <SamePartNumberMessage onCancel={cancelIncorrectPartNumber} />;
    }

    return <PartNotFoundMessage searchedPartNumber={searchedPartNumber} />;
  };

  return (
    <Flex direction="column">
      <Header
        title="Serial Number Doesn’t Match Part Number"
        subtitle={`You have indicated that serial number ${serialNumber} doesn’t belong to part number ${product.partNumber}. Please specify the part number you want included in your RMA request.`}
        withLookup={true}
        cards={headerCard}
      />
      {renderMessage()}
    </Flex>
  );
};

export default IncorrectPartNumber;
